import { onMounted } from "vue";

declare global {
  interface Window {
    isAosInitialized?: boolean | undefined
  }
}

export default function useAosRefresh() {

  onMounted(() => {
    if(window?.isAosInitialized) {
      window.Aos.refreshHard()
      window.isAosInitialized = true
    } else window.Aos.init({ once: true })
  })

}